// moms-harness:anchor v2
// JIRA: LOGISPRD-13875
import type { ShipperInfoMap } from '../queries/useGetSkuAttributeList'

interface ShipperLabeled {
  shipper_code: string
  service_type: string
  shipper_name: string
}

/**
 * 행의 **화주타입·화주명** 두 파생 열을 화주 목록으로 채운다. 다른 열은 건드리지 않는다.
 *
 * ### 왜 표시 단계에서 다시 채우는가
 *
 * 두 열은 BE 응답에 없는 FE 파생 값이라 조회 시점의 `shipperInfo` 로 만들어져 조회 캐시에 들어간다
 * (`toRow`). SKU ID 단독 URL 은 화주 목록을 기다리지 않고 조회하므로(LOGISPRD-13871) **조회가 먼저
 * 끝나면 빈 화주 목록으로 두 열이 비어 캐시된다.** 화주 목록이 와도 조회 키가 같아 다시 만들지 않는다.
 * 그래서 화주 목록이 도착하면 표시 중인 행의 두 열만 다시 채운다 — 사용자가 편집 중인 셀은 그대로다.
 *
 * - 화주 목록에 없는 화주는 **기존 값을 유지한다** (지우지 않는다)
 * - 바뀐 행이 없으면 **같은 배열**을 돌려준다 — `setRows` 에 넣어도 다시 그리지 않는다
 */
export const withShipperLabels = <T extends ShipperLabeled>(rows: T[], shipperInfo: ShipperInfoMap): T[] => {
  let changed = false
  const next = rows.map((row) => {
    const info = shipperInfo[row.shipper_code]
    if (!info || (info.serviceType === row.service_type && info.shipperName === row.shipper_name)) return row
    changed = true
    return { ...row, service_type: info.serviceType, shipper_name: info.shipperName }
  })
  return changed ? next : rows
}
